import React, { useState } from "react";
import { Box, Card, CardContent, Tab, Tabs, Typography } from "@mui/material";
import Report from "./Report/Report";
import Learning from "./Learning/Learning";
import People from "./People/People";

// Reusable TabPanel helper (recommended by MUI docs)
function TabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`audit-tabpanel-${index}`}
      aria-labelledby={`audit-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ pt: 2 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `audit-tab-${index}`,
    "aria-controls": `audit-tabpanel-${index}`,
  };
}

const AuditStats = () => {
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box>
      <Card>
        <CardContent>
          {/* Tabs Header */}
          <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 2 }}>
            <Tabs
              value={value}
              onChange={handleChange}
              variant="fullWidth"
              aria-label="audit stats tabs"
            >
              <Tab label="Report" {...a11yProps(0)} />
              <Tab label="Learning" {...a11yProps(1)} />
              <Tab label="People" {...a11yProps(2)} />
            </Tabs>
          </Box>

          {/* Tab Panels */}
          <TabPanel value={value} index={0}>
            <Report />
          </TabPanel>
          <TabPanel value={value} index={1}>
            <Learning />
          </TabPanel>
          <TabPanel value={value} index={2}>
            <People />
          </TabPanel>
        </CardContent>
      </Card>
    </Box>
  );
};

export default AuditStats;